export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8587.4d8398a6.jpg";